export default __webpack_public_path__ + "static/media/mifel.40a50465.png";